// extracted by mini-css-extract-plugin
export var radioInputRow = "P_w1";
export var radioInputColumn = "P_w2";
export var inputOptionRow = "P_sR";
export var inputOptionColumn = "P_sS";